import { randomIntBetween } from './fnData';

const BACKOFF_STEPS = [
    { delay: 2000, jitter: 1000 },
    { delay: 8000, jitter: 2000 },
    { delay: 20000, jitter: 5000 },
];

export const TOO_MANY_REQUESTS = 429;
export const SINGLE_ATTEMPT = 1;
export const DEFAULT_ATTEMPTS = 2;
export const EXTRA_ATTEMPTS = 4;

export const isRetryableStatus = (status: number): boolean => status === TOO_MANY_REQUESTS || status >= 500;

export const getBackoffMs = (attempt: number): number => {
    const step = BACKOFF_STEPS[Math.min(attempt, BACKOFF_STEPS.length - 1)];

    return step.delay + randomIntBetween(0, step.jitter);
};

export const wait = (ms: number): Promise<void> =>
    new Promise((resolve) => {
        window.setTimeout(resolve, ms);
    });
